<div class="suggestion-container p-6 radius-m white-bg dropdown-shadow">
    <div class="header-wrapper">
        <div class="relative-time-part">
            <ng-container *ngFor="let relative_obj of show_relative_times">
                <p class="px-2 content-m enable-action" [tooltip]="relative_obj.disp" [ngClass]="relative_obj.disp == selectedTimeRange?'selected-time chips-active':'chips-default'" (click)="toggleselectRelativeTime(relative_obj)">{{relative_obj.disp}}</p>

            </ng-container>

        </div>
        <div class="relative-time" >
            <p class=" pl-2 content-m selectable-text enable-action"  #time (click)="openRealtiveTimePanelClick(time)">Relative Time</p>
            <!-- <div class="relative-time-col-1" #timeRangeOrigin>
                <app-overlay-select [data]="relative_time_options" [origin]="timeRangeOrigin"
                    [style]="{'font-size':'9px'}" [label]="'Relative Time'">
                </app-overlay-select>
            </div> -->
        </div>
        <div class="custom-time">
            <p class="content-m selectable-text enable-action" #CustomTime (click)="openCustomTimePanelClick(CustomTime)">Custom Time Range</p>
            <!-- <div class="custome-time" #customRangeOrigin>
                <app-overlay-select [data]="relative_time_options" [origin]="customRangeOrigin"
                    [style]="{'font-size':'9px'}" [label]="'Custome Time'">
                </app-overlay-select>
            </div> -->
        </div>
        <div class="fields-suggestion">
            <ng-container *ngFor="let chip of suggestion_chips">
                <span class="chip-wrapper">
                    <span class="chip-key" [tooltip]="selectedfield">{{selectedfield}}</span>
                    <span class="chip-opertor"> =</span>"
                    <span class="chip-value" [tooltip]="chip">{{chip}}</span>"
                </span>
            </ng-container>
        </div>
        <div class="show-events">
            <p class="content-m selectable-text enable-action">Show 100 Events</p>
        </div>
    </div>
    <div class="body-wrapper">
        <div class="platform-wrapper pl-5">

            <div class="header">
                <p class="content-l bold-text primary-text">Platforms</p>

            </div>
            <div class="action-wrapper">
                <!-- <div class="search-container">
                    <form action="/search" method="get">
                      <input class="search" id="searchleft" type="search" name="q" placeholder="Search">
                      <label class="button searchbutton" for="searchleft"><span class="mglass">&#9906;</span></label>
                    </form>
                </div> -->
                <div class="custom-search">
                    <img src="assets/settings/search-small.svg">
                    <input class="input-border" type="search" id="input" placeholder="Type to search here" [formControl]="platformSearch"
                        (click)="$event.stopPropagation()">
                </div>
                <div></div>
            </div>
            <ng-container *ngIf="!suggestionplatformSpinnerState">
                <div class="content">
                    <ng-container *ngIf="platformList.length>0">
                        <ng-container *ngFor="let platforms of platformList">
                            <div class="display-text border-light-bottom pl-0 p-3">
                                <span class="content-m" [tooltip]="platforms.disp"
                                    [ngClass]="platforms.disp == selectedPlatform?'enable':'disable'"
                                    (click)="ClickedPlatform(platforms)">{{platforms.disp}}</span>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="platformList.length==0">
                        <div class="suggestion-noresult-container">
                            <img src="assets/alerts/empty-data.svg" alt="">
                            <span class="content-l">No result found</span>
                        </div>
                    </ng-container>

                </div>
            </ng-container>
            <ng-container *ngIf="suggestionplatformSpinnerState">
                <div class="spinner-wrapper">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>

        </div>
        <div class="source-wrapper pl-5 border-light-left">

            <div class="header">
                <p class="content-l bold-text primary-text">Sources</p>
            </div>
            <div class="action-wrapper pl-3">
                
                    <label class="checkbox-container content-l primary-text">
                        <span class="dot"></span>
                        <input type="checkbox" class="shadow-none" (click)="$event.stopPropagation()" [formControl]="sourceSelectAll">
                        <!-- <span class="checkmark"></span> -->
                    </label>
                
                <div class="custom-search">
                    <img src="assets/settings/search-small.svg">
                    <input class="input-border" type="search" id="input" placeholder="Type to search here" [formControl]="sourceSearch"
                        (click)="$event.stopPropagation()">
                </div>
                <div>

                </div>

            </div>
            <ng-container *ngIf="!suggestionsourceSpinnerState">
                <div class="content">
                    <ng-container *ngIf="selectedHost.length>0">
                        <ng-container *ngFor="let host of selectedHost;let i =index;">
                            <div class="display-text border-light-bottom pl-0 p-3">
                                <label class="checkbox-container content-l primary-text" [tooltip]="host.disp">{{host.disp}}
                                    <span class="dot content-m"></span>
                                    <input type="checkbox" [checked]="host.isSelected" (click)="selectedSource(i,host,$event)">
                                    <!-- <span class="checkmark"></span> -->
                                </label>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="selectedHost.length==0">
                        <div class="suggestion-noresult-container">
                            <img src="assets/alerts/empty-data.svg" alt="">
                            <span class="content-l">No result found</span>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="suggestionsourceSpinnerState">
                <div class="spinner-wrapper">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
        </div>
        <div class="fields-wrapper pl-5 border-light-left">

            <div class="header">
                <p class="content-l bold-text primary-text">Fields</p>
            </div>
            <div class="action-wrapper">
                <div class="custom-search">
                    <img src="assets/settings/search-small.svg">
                    <input class="input-border" type="search" id="input" placeholder="Type to search here" [formControl]="fieldsSearch"
                        (click)="$event.stopPropagation()">
                </div>
                <div>

                </div>
            </div>
            <ng-container *ngIf="!suggestionfieldSpinnerState">
                <div class="content">
                    <ng-container *ngIf="fieldsList.length>0">
                        <ng-container *ngFor="let fields of fieldsList">
                            <div class="display-text border-light-bottom pl-0 p-3" *ngIf="fields.is_view">
                                <img class="icon-xs" [src]="fields.display_type=='Text'?'assets/text-field.svg':'assets/fields.svg'"
                                    alt="">
                                <span class="content-m" [tooltip]="fields.disp"
                                    [ngClass]="fields.disp == selectedfield?'enable':'disable'"
                                    (click)="SelectedFields(fields,$event)">{{fields.disp}}</span>
                                <div class="display-count">
                                    <!-- <p class="display-key">Unique</p> -->
                                    <p class="value primary-text bold-text m-0 content-m">{{fields.count}}</p>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="fieldsList.length==0">
                        <div class="suggestion-noresult-container">
                            <img src="assets/alerts/empty-data.svg" alt="">
                            <span class="content-l">No result found</span>
                        </div>
                    </ng-container>

                </div>
            </ng-container>
            <ng-container *ngIf="suggestionfieldSpinnerState">
                <div class="spinner-wrapper">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
        </div>
        <div class="value-wrapper border-light-left pl-5">

            <div class="header">
                <p class="content-l bold-text primary-text">Values</p>
            </div>
            <div class="action-wrapper">

                <div class="custom-search">
                    <img src="assets/settings/search-small.svg">
                    <input class="input-border" type="search" id="input" placeholder="Type to search here" [formControl]="valueSearch"
                        (click)="$event.stopPropagation()">
                </div>
                <div></div>
            </div>
            <ng-container *ngIf="!suggestionvalueSpinnerState">
                <div class="content">
                    <ng-container *ngIf="fieldsValue.length>0">
                        <ng-container *ngFor="let lexicon of fieldsValue">
                            <ng-container *ngIf="lexicon!='--NA--'">
                                <div class="display-text  border-light-bottom pl-0 p-3">
                                    <span class="content-m" [tooltip]="lexicon"
                                        [ngClass]="lexicon == selectedPlatform?'enable':'disable'">{{lexicon}}</span>
                                </div>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="fieldsValue.length==0">
                        <div class="suggestion-noresult-container">
                            <img src="assets/alerts/empty-data.svg" alt="">
                            <span class="content-l">No result found</span>
                        </div>
                    </ng-container>

                </div>
            </ng-container>
            <ng-container *ngIf="suggestionvalueSpinnerState">
                <div class="spinner-wrapper">
                    <mat-spinner class="spinner" diameter=20></mat-spinner>
                </div>
            </ng-container>
        </div>
        
    </div>
    <div class="alert-danger content-s alert-text ml-3">
        <div *ngIf="sourceErrorState">
            <!-- Fullname is required -->
            {{sourceErrorMsg}}
        </div>
    </div>
    <div class="footer-wrapper">
        <button mat-button class="cancel"
            [ngClass]="assetsService.assetsSpinnerState ? 'disable-action':'enable-action'" (click)="formCancel()"
            tabindex="0">{{assetsService.lables.cancel}}</button>
        <!-- to apply the selected hosts for search -->
        <button mat-button class="submit"
            [ngClass]="assetsService.assetsSpinnerState ? 'disable-action':'enable-action'" (click)="formSubmit()"
            tabindex="1">{{assetsService.lables.apply}}</button>
    </div>
</div>